import Post from "../Post";
import getToken from "../token";

export default function buyTutorial(id, currency) {
 
  return Post("blog/buyBlog", {
    token: getToken(),
    id: id,
    currency: currency,
  });
}
